<template>
  <div class="tinto-page">
    <Loading :isActive="loading" />

    <div class="tinto-filters">
      <div class="tinto-filtros__linha">
        <div class="tinto-filtros__busca">
          <input class="form-control" v-model="filtros.termo" placeholder="Busca rápida: nome ou código..." @keyup.enter="load()" />
        </div>
        <div class="tinto-filtros__acoes">
          <button class="button button-primary button--icone" @click="load()" title="Buscar">
            <fa-icon icon="search" />
          </button>
          <button
            :class="['button', 'button--auto', filtrosAbertos ? 'button-primary' : '']"
            @click="filtrosAbertos = !filtrosAbertos"
          >
            <fa-icon icon="filter" /> Filtros
            <span v-if="totalFiltrosAtivos" class="tinto-filtros__contador">{{ totalFiltrosAtivos }}</span>
          </button>
        </div>
      </div>

      <div class="tinto-filtros__painel" v-if="filtrosAbertos">
        <CRow>
          <CCol md="3">
            <div class="tinto-campo">
              <label class="tinto-campo__label">Fabricante</label>
              <select class="form-control" v-model="filtros.fabricanteId" @change="onFabricanteChange()">
                <option value="">Todos</option>
                <option v-for="(n,id) in fabricantes" :key="id" :value="id">{{ n }}</option>
              </select>
            </div>
          </CCol>
          <CCol md="3">
            <div class="tinto-campo">
              <label class="tinto-campo__label">Origem</label>
              <select class="form-control" v-model="filtros.integracaoId" @change="load()">
                <option value="">Todas</option>
                <option v-for="i in integracoesDoFabricante" :key="i.id" :value="i.id">{{ i.descricao }}</option>
              </select>
            </div>
          </CCol>
          <CCol md="3">
            <div class="tinto-campo">
              <label class="tinto-campo__label">Situação</label>
              <select class="form-control" v-model="filtros.ativo" @change="load()">
                <option value="">Todas</option>
                <option value="1">Ativas</option>
                <option value="0">Inativas</option>
              </select>
            </div>
          </CCol>
          <CCol md="3">
            <div class="tinto-campo">
              <label class="tinto-campo__label">Nome</label>
              <input class="form-control" v-model="filtros.nome" placeholder="contém..." @keyup.enter="load()" />
            </div>
          </CCol>
          <CCol md="3">
            <div class="tinto-campo">
              <label class="tinto-campo__label">Código externo</label>
              <input class="form-control" v-model="filtros.idExterno" placeholder="contém..." @keyup.enter="load()" />
            </div>
          </CCol>
          <CCol md="3">
            <div class="tinto-campo">
              <label class="tinto-campo__label">Código de exibição</label>
              <input class="form-control" v-model="filtros.codigoExibicao" placeholder="contém..." @keyup.enter="load()" />
            </div>
          </CCol>
        </CRow>
      </div>

      <div class="tinto-chips" v-if="chipsFiltros.length">
        <span class="tinto-chips__titulo">Filtrando por</span>
        <span class="tinto-filtro-chip" v-for="chip in chipsFiltros" :key="chip.chave">
          <strong>{{ chip.rotulo }}:</strong> {{ chip.valor }}
          <span class="tinto-filtro-chip__remover" @click="removerFiltro(chip.chave)" title="Remover filtro">&times;</span>
        </span>
        <button class="tinto-chips__limpar" @click="limparFiltros()">limpar tudo</button>
      </div>
    </div>

    <div class="tinto-table-wrap">
      <table class="tinto-table">
        <thead><tr>
          <th style="width:50px">ID</th>
          <th style="width:280px" class="tinto-sortable" :class="{'is-active': sort.by==='nome'}" @click="sortBy('nome')">
            Nome<fa-icon :icon="sort.by==='nome' ? (sort.dir==='asc' ? 'arrow-up' : 'arrow-down') : 'arrow-down'" class="sort-icon" />
          </th>
          <th style="width:140px" class="tinto-sortable" :class="{'is-active': sort.by==='id_externo'}" @click="sortBy('id_externo')">
            Código Externo<fa-icon :icon="sort.by==='id_externo' ? (sort.dir==='asc' ? 'arrow-up' : 'arrow-down') : 'arrow-down'" class="sort-icon" />
          </th>
          <th style="width:110px">Fabricante</th>
          <th style="width:130px">Origem</th>
          <th style="width:60px;text-align:center">Hex</th>
        </tr></thead>
        <tbody>
          <tr v-if="items.length === 0"><td colspan="6" class="tinto-table__empty">Nenhuma cor encontrada</td></tr>
          <tr v-for="r in items" :key="r.id">
            <td>{{ r.id }}</td>
            <td class="tinto-table__primary">
              <span v-if="r.nome">{{ r.nome }}</span>
              <span v-else class="tinto-table__muted">—</span>
            </td>
            <td>{{ r.cod }}</td>
            <td>{{ r.fabricanteNome }}</td>
            <td>
              <span v-if="r.integracaoNome">{{ r.integracaoNome }}</span>
              <span v-else class="tinto-table__muted">—</span>
            </td>
            <td style="text-align:center">
              <span
                v-if="r.hexa"
                class="tinto-cor-swatch"
                :style="{ background: r.hexa }"
                :title="r.hexa"
              ></span>
              <span v-else class="tinto-table__muted">—</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="tinto-pagination" v-if="paginator.last_page > 1">
      <pagination :data="paginator" :limit="5" @pagination-change-page="load" />
    </div>
  </div>
</template>

<script>
import Loading from "../../components/Loading";
import listagemMixin from "./listagemMixin";

export default {
  name: "tintometrico-cor",
  components: { Loading },
  mixins: [listagemMixin],
  props: ['fabricantes', 'integracoes'],

  data() {
    return {
      listagemEndpoint: '/admin/tintometrico/cor',
      sort: { by: 'nome', dir: 'asc' },
      filtros: { termo: '', fabricanteId: '', ativo: '', integracaoId: '', nome: '', idExterno: '', codigoExibicao: '' },
      rotulosFiltros: {
        termo: 'Busca', fabricanteId: 'Fabricante', integracaoId: 'Origem', ativo: 'Situação',
        nome: 'Nome', idExterno: 'Código externo', codigoExibicao: 'Código de exibição',
      },
    };
  },

  computed: {
    // Origens disponíveis para escolher: quando um fabricante está selecionado,
    // só as integrações dele. O catálogo tem uma cópia por integração quando o
    // fabricante tem mais de uma fonte (duas máquinas, por exemplo).
    integracoesDoFabricante() {
      if (!this.filtros.fabricanteId) return this.integracoes;
      return this.integracoes.filter((i) => String(i.fabricanteId) === String(this.filtros.fabricanteId));
    },
  },

  methods: {
    descreverFiltro(chave, valor) {
      if (chave === 'fabricanteId') return this.fabricantes[valor] || valor;
      if (chave === 'integracaoId') return this.nomeDaOpcao(this.integracoes, valor);
      if (chave === 'ativo') return valor === '1' ? 'ativas' : 'inativas';
      return valor;
    },

    // Cada filtro tem o seu parâmetro e todos valem juntos (AND no backend).
    appendFiltros(params) {
      if (this.filtros.fabricanteId) params.append('fabricante_id', this.filtros.fabricanteId);
      if (this.filtros.ativo !== '') params.append('ativo', this.filtros.ativo);
      if (this.filtros.termo) params.append('q', this.filtros.termo);
      if (this.filtros.nome) params.append('nome', this.filtros.nome);
      if (this.filtros.idExterno) params.append('id_externo', this.filtros.idExterno);
      if (this.filtros.codigoExibicao) params.append('codigo_exibicao', this.filtros.codigoExibicao);
    },
  },
};
</script>
